import { EGroupedItemsType } from '~/src/services/properties';

export const config = {
    title: {
        name: 'title',
        label: 'Заголовок',
        type: EGroupedItemsType.String,
        order: 0,
    },
    url: {
        name: 'url',
        label: 'URL',
        type: EGroupedItemsType.String,
        order: 1,
    },
    isActive: {
        name: 'isActive',
        label: 'Включить лендинг',
        type: EGroupedItemsType.Boolean,
        order: 2,
    },
    seo: {
        groupName: 'seo',
        label: 'Метатеги:',
        order: 3,
        items: {
            title: {
                name: 'title',
                label: 'SEO-заголовок',
                type: EGroupedItemsType.Text,
            },
            description: {
                name: 'description',
                label: 'SEO-description',
                type: EGroupedItemsType.Text,
            },
            robots: {
                name: 'robots',
                label: 'Robots',
                type: EGroupedItemsType.Text,
            },
        },
    },
    cities: {
        name: 'cities',
        label: 'Выбор городов',
        type: EGroupedItemsType.CityFilter,
        order: 4,
    },
    available:{
        groupName: 'available',
        label: 'Доступно:',
        order: 5,
        items: {
            isAuth: {
                name: 'isAuth',
                label: 'клиентам',
                type: EGroupedItemsType.Boolean,
            },
            isGuest: {
                name: 'title', // TODO: что-то пошло не так!!
                label: 'гостям',
                type: EGroupedItemsType.Boolean,
            },
        },
    },
    additionalData:{
        groupName: 'additionalData',
        label: 'Дополнительно:',
        order: 6,
        items: {
            styles: {
                name: 'styles',
                label: 'Стили',
                type: EGroupedItemsType.Text,
            },
            background: {
                name: 'background',
                label: 'Фон',
                type: EGroupedItemsType.ColorPicker,
            },
            backgroundWebp: {
                name: 'webp',
                type: EGroupedItemsType.Hidden,
            },
            issueLink: {
                name: 'issueLink',
                label: 'Ссылка на задачу/макет',
                type: EGroupedItemsType.String,
            },
        },
    },
};
